export const ASK_FOR_TAPE_ROLE =
  'Ask your administrator to grant you the Portfolio Manager or Deal Manager role.';

export const NO_TAPE_ROLE_MESSAGE = `You don’t have permission to do this. ${ASK_FOR_TAPE_ROLE}`;

// api Tapestry error codes → user-facing messages. Mirrors the resolver's
// E-4xxx / E-50xx codes (tapestryJobStatus.ts). Keep in sync if codes change.
export const TAPESTRY_ERROR_MESSAGES: Record<string, string> = {
  'E-4001': 'We couldn’t find this tape — it may have been removed.',
  'E-4030': NO_TAPE_ROLE_MESSAGE,
  'E-4090': 'This tape isn’t awaiting column mapping right now — refresh to see its status.',
  'E-4091': 'This tape isn’t awaiting review right now — refresh to see its status.',
  'E-4092': 'This step can’t run right now. Refresh and try again.',
  'E-4093': 'This tape isn’t ready to save yet. Give it a moment and try again.',
  'E-4094': 'This file is password protected. Remove the password and upload it again.',
  'E-4220':
    'Map Account Id to your tape’s 4C Asset ID column — it’s the only loan ID that’s unique across the banks in an FDIC portfolio.',
  'E-5030': 'Processing isn’t configured for this environment. Please contact support.',
  'E-5031':
    'We couldn’t start processing. Please try again, or contact support if it keeps happening.',
};

export const tapestryErrorMessage = (
  code: string | undefined,
  fallback = 'Something went wrong. Please try again.',
): string => (code && TAPESTRY_ERROR_MESSAGES[code]) || fallback;
